<template>
  <view>
    <cube-button bindtap="showActionSheet">action-sheet-active</cube-button>
    <cube-action-sheet
      wx:ref="actionSheet"
      title="我是标题~~~"
      inputData="{{inputData}}"
      active="{{active}}"
      bind:select="onSelect"
      bind:cancel="onCancel"
      bind:maskClose="onMaskClose"
    />
    <cube-toast
      txt="{{ selectContent }}"
      wx:ref="selectToast">
    </cube-toast>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    inputData: [
      {
        content: '舒适型'
      },
      {
        content: '七座商务'
      },
      {
        content: '豪华型'
      }
    ],
    active: 0,
    selectContent: ''
  },
  methods: {
    onSelect(selectData) {
      const { item, index } = selectData.detail
      this.selectContent = `Clicked ${item.content}`
      this.active = index
      this.$refs.selectToast.show()
    },
    onCancel() {
      this.selectContent = 'Clicked canceled '
      this.$refs.selectToast.show()
    },
    onMaskClose() {
      this.selectContent = 'Clicked maskClose '
      this.$refs.selectToast.show()
    },
    showActionSheet() {
      this.$refs.actionSheet.show()
    }
  }
})
</script>

<style lang="stylus">

</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-action-sheet": "@mpxjs/mpx-cube-ui/src/components/action-sheet/index",
      "cube-toast": "@mpxjs/mpx-cube-ui/src/components/toast/index"
    }
  }
</script>
